import "./SocialMedia.scss";

export default function SocialMedia() {
  return (
    <div>
      <div class="container">
     

        <div class="effect jaques">
          <div class="buttons">
            <a onClick={()=>window.open("https://www.linkedin.com/in/anurag-sharma-843864204/")} href="#" class="in" title="Join us on Linked In">
              <i class="fa fa-linkedin" aria-hidden="true"></i>
            </a>
           
            <a href="#" class="vimeo" title="Follow me on github">
              <i class="fa fa-github" aria-hidden="true"></i>
            </a>
            <a onClick={()=>window.open("https://github.com/anuragsharma1111994")} href="#" class="tw" title="Join us on Twitter">
              <i class="fa fa-twitter" aria-hidden="true"></i>
            </a>
            <a onClick={()=>window.open("https://www.instagram.com/anuragshxrma_/")} href="#" class="insta" title="Follow me on Instagram">
              <i class="fa fa-instagram" aria-hidden="true"></i>
            </a>
            <a href="#" class="pinterest" title="9552062434">
              <i class="fa fa-phone" aria-hidden="true"></i>
            </a>
            <a href="#" class="g-plus" title="sharma54anurag@gmail.com">
              <i class="fa fa-google-plus" aria-hidden="true"></i>
            </a>
          </div>
        </div>

   
      </div>
      {/* <i class="fab fa-linkedin"></i>
      <i class="fab fa-github"></i>
      <i class="fab fa-instagram"></i>
      <i class="fas fa-phone-alt"></i>
      <i class="fas fa-envelope"></i> */}
    </div>
  );
}
